import { render } from "./SimLinks.vue?vue&type=template&id=9285e928&scoped=true"
import script from "./SimLinks.vue?vue&type=script&lang=js"
export * from "./SimLinks.vue?vue&type=script&lang=js"

import "./SimLinks.vue?vue&type=style&index=0&id=9285e928&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9285e928"]])

export default __exports__